import $ from 'jquery'

const States = (($) => {
	const Endpoint               = '/_system/api/states'

	class States {

		constructor(){

		}


		list(country, callback){
			return $.ajax({
				url 		: Endpoint,
				data		: { country : country },
				method 		: 'GET',
				dataType	: 'json',
			});
		}
	}

	return new States()
})($)

export default States
